import { BaseDataTransferObject } from '../base-data-transfer-object';
import { ZipCode } from '../common';

export class BillingInformation extends BaseDataTransferObject {
    public patientId?: number;
    public billTypeId?: number;
    public billType?: string;
    public payerId?: number;
    public payer?: string;
    public order?: number;
    public checkAdvancedBeneficiaryNotice?: boolean;
    public position?: number;
    public zipCodeId?: number;
    public insuranceId?: string;
    public groupNumber?: string;
    public lastName: string = '';
    public firstName: string = '';
    public middleName: string = '';
    public gender?: string;
    public differentThanPatient?: boolean;
    public birthDate: string | number | Date  = '';
    public address?: string;
    public relationship?: string;
    public phone: string = '';
    public zipCode?: ZipCode | string;
    public zipCodeName?: string;
    public zipCodePlus4?: string;
}
